module.exports = __webpack_public_path__ + "img/GAME_PAINTBALL.8de1413f.png";